import { ready } from '~/core'
import HTTP from '~/utils/Http'
import media from '~/utils/media'

ready('header', '.header:not(.header--mb)', (header) => {
  const http = new HTTP();
  const logo = header.querySelector('.header-logo');
  const collapseBuffer = 50;
  const mobileScrollBuffer = 100;
  const mobileCollapse = 400;
  const desktopCollapse = 300;

  let condensed = false;
  let logoImg = logo.querySelector('.header-logoImg');
  let lastScroll = 0;
  let updateHeader = false;

  logoImg.src = logoImg.src.split('?')[0] + "?v=" + new Date().getTime();

  const resizeObserver = new ResizeObserver(entries => {
    for (let entry of entries) {
      const { height } = entry.contentRect;
      const topVal = parseFloat(getComputedStyle(header).top) || 0;
      
      document.body.parentElement.style.setProperty('--headerHeight', `${height + topVal}px`);
      window.headerHeight = height + topVal;
    }
  });

  resizeObserver.observe(header);
  


  requestAnimationFrame(checkNav);

  function checkNav() {
    updateHeader = false;

    const scroll = window.scrollY || document.scrollingElement.scrollTop;

    if (media.md.matches) {
      if (header.classList.contains('header--collapsed'))
        header.classList.remove('header--collapsed');

      if (condensed && scroll > desktopCollapse) {
        header.classList.add('header--condensed');
        condensed = false;
      }
      else if(!condensed && scroll < desktopCollapse - collapseBuffer) {
        header.classList.remove('header--condensed');
        condensed = true;
      }
    } else {
      if (condensed) {
        header.classList.remove('header--condensed');
        condensed = false;
      }

      if (scroll > mobileCollapse && Math.abs(scroll - lastScroll - collapseBuffer) > mobileScrollBuffer) {
        if (scroll > lastScroll - collapseBuffer) 
          header.classList.add('header--collapsed');
        else 
          header.classList.remove('header--collapsed');

        lastScroll = scroll <= 0 ? 0 : scroll; 
      }
      else if (scroll <= mobileCollapse) {
        if (header.classList.contains('header--collapsed'))
          header.classList.remove('header--collapsed');
      }
    }
  }

  document.addEventListener('scroll', () => {
    if (!updateHeader) {
      updateHeader = true;
      requestAnimationFrame(checkNav);
    }
  });

  window.addEventListener('resize', () => {
    if (!updateHeader) {
      updateHeader = true;
      requestAnimationFrame(checkNav);
    }
  });
})

ready('header_desktop_nav', '.header', (header) => {
  const items = [...header.querySelectorAll('.nav-item')]

  items.forEach((itm) => {
    const sibs = [...items].filter((i) => i !== itm)

    itm.addEventListener('click', (e) => {
      if (media.md.matches) {
        itm.classList.toggle('is-open')
        let overlay = document.querySelector('.header-overlay')
        if (overlay.classList.contains('is-open') && !itm.classList.contains('is-open')) {
          overlay.classList.remove('is-open')
        } else {
          overlay.classList.add('is-open')
        }

        sibs.forEach((sib) => sib.classList.remove('is-open'))
      }
    })
  })

  document.body.addEventListener('click', (e) => {
    if (media.md.matches) {
      if (e.target.closest('.nav-item')) return
      let overlay = document.querySelector('.header-overlay')
      if (overlay && overlay.classList && overlay.classList.contains('is-open')) {
        overlay.classList.remove('is-open')
      }
      items.forEach((itm) => itm.classList.remove('is-open'))
    }
  })
})

ready('header_masonry', '.header', (header) => {
  function resizeGridItem(item) {
    const grid = header.querySelector('.menu-body')
    const rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'))
    const rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'))
    const rowSpan = Math.ceil(
      (item.querySelector('.menu-contentInner').getBoundingClientRect().height + rowGap) / (rowHeight + rowGap),
    )

    item.style.gridRowEnd = 'span ' + rowSpan
  }

  function resizeAllGridItems() {
    if (!media.md.matches) return
    const allItems = header.querySelectorAll('.menu-content')
    allItems.forEach((item) => {
      resizeGridItem(item)
    })
  }

  window.addEventListener('resize', resizeAllGridItems)
  resizeAllGridItems()
})

ready('mobile_nav_top_level', '.header-nav', (nav) => {
  const header = nav.closest('.header')
  const topLevels = [...nav.querySelectorAll('.nav-item:not(.nav-item--collapse)')]
  const menus = [...nav.querySelectorAll('.nav-menu .menu-body')]

  menus.forEach((menu) => menu.addEventListener('click', (e) => e.stopPropagation()))

  topLevels.forEach((topLevel) =>
    topLevel.querySelector('.nav-text').addEventListener('click', function () {
      if (!media.md.matches) {
        topLevels.forEach((tl) => (tl != topLevel ? clearTopLevel(topLevel) : false))

        if (topLevel.classList.contains('is-active') || topLevel.matches(':focus-within')){
          clearTopLevel(topLevel)
        }
        else {
          nav.style.setProperty('--scrollPos', -1 * nav.scrollTop + 'px')
          topLevel.classList.add('is-active')
        }
      }
    }),
  )

  media.md.addListener((e) => {
    if (e.matches) {
      topLevels.forEach((topLevel) => {
        clearTopLevel(topLevel)
        topLevel.querySelector('.nav-menu') ? (topLevel.querySelector('.nav-menu').style.height = '') : false
      })
    }
  })

  function clearTopLevel(topLevel) {
    topLevel.classList.remove('is-active')
  }
})

ready('mobile_nav_sub_level', '.header .menu-contentInner', (menu) => {
  const titles = [...menu.querySelectorAll('.menu-title')]
  const list = menu.querySelector('.menu-list')

  titles.forEach((title) =>
    title.addEventListener('click', () => {
      if (!media.md.matches) {
        let start = list.offsetHeight + 'px'
        menu.classList.toggle('is-active')
        let end = list.offsetHeight + 'px'

        list.animate(
          [
            {
              height: start,
            },
            {
              height: end,
            },
          ],
          {
            duration: 250,
            easing: 'ease',
          },
        )
      }
    }),
  )
})

ready('mobile_nav_sub_level_collapsed', '.nav-item--collapse', (menu) => {
  const title = menu.querySelector(':scope > .nav-text')
  const list = menu.querySelector(':scope > .nav-menu')

  title.addEventListener('click', (e) => {
    if (!media.md.matches) {
      e.stopImmediatePropagation()
      let start = list.offsetHeight + 'px'
      menu.classList.toggle('is-active')
      let end = list.offsetHeight + 'px'

      list.animate(
        [
          {
            height: start,
          },
          {
            height: end,
          },
        ],
        {
          duration: 250,
          easing: 'ease',
        },
      )
    }
  })
})

// ready('mobile_nav_bucket', '.nav-item--collapse', item => {
// 	retach(item, {
// 		destination: '.nav-item--bucket .nav-menu',
// 		mediaQuery: 768,
// 		movedClass: 'is-collapsed',
// 		moveMethod: 'append',
// 	});
// });

ready('itemLogin', '.nav-item--login', (itemLogin) => {
  const showLogin = () => {
    const loginHero = document.querySelector('.heroMain')
    if (media.md.matches) {
      if (!loginHero) {
        itemLogin.style.display = 'flex'
      }
    } else {
      itemLogin.style.display = ''
    }
  }
  showLogin()
  window.addEventListener('resize', showLogin)
})

ready('headerMb', '.header--mb', (header) => {
  window.addEventListener('scroll', function () {
    if (window.scrollY > header.offsetHeight) {
      header.classList.add('is-sticky')
    } else {
      header.classList.remove('is-sticky')
    }
  })
})

ready('headerSearchMb', '.header-search', (search) => {
  const openBtn = search.querySelector('.header-searchOpen')
  const closeBtn = search.querySelector('.header-searchClose')
  const searchField = search.querySelector('.header-searchField')

  openBtn.addEventListener('click', (e) => {
    e.preventDefault()
    searchField.classList.add('is-open')
  })
  closeBtn.addEventListener('click', (e) => {
    e.preventDefault()
    searchField.classList.remove('is-open')
  })
})

ready('toggleMobileNav', '.js-mobile-nav', (mobileNav) => {
  let headerHeight
  const nav = document.querySelector('.header-nav')
  const toggles = nav.querySelectorAll('.header-nav__heading')
  const backButtons = nav.querySelectorAll('.menu-back')

  const header = document.querySelector('.header')
  let alerts = document.querySelector('.alert')

  if (alerts) {
    headerHeight = header.offsetHeight + alerts.offsetHeight
  } else {
    headerHeight = header.offsetHeight
  }

  nav.style.setProperty('--mobileOffset', `${headerHeight}px`)

  window.addEventListener('resize', () => {
    if (alerts) {
      headerHeight = header.offsetHeight + alerts.offsetHeight
    } else {
      headerHeight = header.offsetHeight
    }
    nav.style.setProperty('--mobileOffset', `${headerHeight}px`)
  })

  if (alerts) {
    alerts.addEventListener('click', () => {
      headerHeight = header.offsetHeight + alerts.offsetHeight
      nav.style.setProperty('--mobileOffset', `${headerHeight}px`)
    })
  }

  backButtons.forEach(backButton => {
    backButton.addEventListener('click', (e) => {
      let parent = e.target.closest('.nav-item')
      parent.classList.remove('is-active');
    });
  });

  mobileNav.addEventListener('click', () => {
    const isHeaderOpen = header.classList.contains('is-active');

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    })

    if (alerts) {
      headerHeight = header.offsetHeight + alerts.offsetHeight
    } else {
      headerHeight = header.offsetHeight
    }
    nav.style.setProperty('--mobileOffset', `${headerHeight}px`)

    document.body.classList.toggle('is-locked')
    header.classList.toggle('is-active')
    mobileNav.classList.toggle('is-active')
    nav.classList.toggle('is-active')

    if (isHeaderOpen) {
      setTimeout(() => {
        nav.querySelectorAll('.nav-list .is-active').forEach(i => i.classList.remove('is-active'));
      }, 500);
    }
  })
})
